const parseDao = require("actdao/ParseBaseDao");
const tournamentResultDao = require("actdao/TournamentResultDao");
const notificationActions = require("components/notification/NotificationActions");
const TournamentUserResultDic = require("util/TournamentUserResultDic"),
    TournamentUserTeamResultDic = require("util/TournamentUserTeamResultDic");

const {TournamentRound} = require("parse/_Domain");

class TournamentResultDicActions {

    constructor() {
    }
    // params: tConfigCombinedAge, needFinalElimination, needFinalAdd
    static async loadTournamentUserResult(tournament, tournamentConfigAge, tournamentConfigBow, params) {
        const isLippek = tournament.getBowUnionID() ? tournament.getBowUnionID().isTypeLippek() : false;
        const isCupCombineAge = params.tConfigCombinedAge != null && tournament.getTournamentCupOptionID() ? tournament.getTournamentCupOptionID().hasCombineAge() : false;
        const userResultDic = new TournamentUserResultDic();
        if (tournament.getBowUnionID() != null) {
            userResultDic.setSortByMissFirst(tournament.getBowUnionID().isSortByMissFirst())
        }
        if (params.needFinalElimination) {
            userResultDic.setEState(TournamentRound.prototype.elimination.stateFinal)
            userResultDic.setTournamentSecondGroup(tournament.getTournamentConfigAge());
        } else if (!isLippek) {
            // only needed if not Lippek
            if (isCupCombineAge) {
                userResultDic.setTournamentCombineGroups(tournament.getTournamentCupOptionID().getCombineTConfigAgeIDs());
                userResultDic.setTournamentSecondGroup([params.tConfigCombinedAge])
            } else if (params.tConfigCombinedAge) {
                // combine all configAgeIds
                userResultDic.setTournamentCombineGroups(tournament.getTournamentConfigAge());
                userResultDic.setTournamentSecondGroup([params.tConfigCombinedAge])
            } else {
                userResultDic.setTournamentSecondGroup(tournament.getTournamentConfigAge());
            }
        }
        return await tournamentResultDao.loadTournamentUserResult(tournament, tournamentConfigAge, tournamentConfigBow, params)
            .then(tUsers => {
                tUsers.forEach(function (tUser) {
                    if (isLippek) {
                        userResultDic.addSortTournamentUserLippek(tUser);
                    } else if (params.needFinalElimination) {
                        userResultDic.addSortEliminationTournamentUser(tUser);
                    } else {
                        userResultDic.addSortTournamentUser(tUser, params.needFinalAdd);
                    }
                });
                return userResultDic;
            })
            .catch(error => {
                error.trace = "TREA.loadTURes";
                notificationActions.parseError(error);
                return userResultDic;
            })
    }

    static async loadTournamentUserTeamResult(tournament, groupType) {
        const userResultDic = new TournamentUserTeamResultDic();
        userResultDic.setGroupType(groupType, tournament.getEndDate());
        return await tournamentResultDao.loadTournamenUserTeam(tournament)
            .then(tUserTeams => {
                tUserTeams.forEach(function (tUserTeam) {
                    userResultDic.addSortTournamentUserTeam(tUserTeam);
                });
                return userResultDic;
            })
            .catch(error => {
                error.trace = "TREA.loadTURes";
                notificationActions.parseError(error);
                return userResultDic;
            });
    };
}
module.exports = TournamentResultDicActions;